import base from './base';
import palette from './palette';

/** Shared with tooltips MUI's `Tooltip` doesn't render, e.g. the charts' `ChartTooltip`. */
export const tooltipStyles = {
  backgroundColor: palette.common.black,
  color: palette.common.white,
  fontSize: '10px',
  fontWeight: 400,
  padding: '3px 6px',
  borderRadius: `${base.shape.borderRadius}px`,
};

export const tooltipArrowStyles = {
  color: palette.common.black,
};

const tooltip = {
  MuiTooltip: {
    styleOverrides: {
      tooltip: tooltipStyles,
      arrow: tooltipArrowStyles,
    },
  },
};

export default tooltip;
